import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoCardContainer } from '../styles';

const InfoCard = () => {
  const { t } = useTranslation();
  return (
    <InfoCardContainer>
      <p>
        {t('publisher.step4.module1.infoCard.text.part1')}
        <b>{t('publisher.step4.module1.infoCard.text.part2')}</b>
      </p>
    </InfoCardContainer>
  );
};

export { InfoCard };
